import React, { useState } from 'react';
import { Upload } from 'antd';
import PropTypes from 'prop-types';
import axios from 'utilities/axios';
import { getBase64 } from 'utilities/common';
import './styles.scss';

const MyUploadAvatar = ({
  height,
  onChange,
  disabled,
  imageSelected
}) => {
  const triggerUpload = () => {
    const el = document.querySelector('.upload-avatar-custom input');
    el && el.click();
  };

  const handleUploadFile = async file => {
    const { name } = file;
    const fileBase64 = await getBase64(file);
    const payload = {
      name,
      contentBase64: fileBase64,
      folder: 'signup',
      isEnableCompressImage: true,
      imageMaxWidthPx: 0,
      imageMaxHeightPx: 0
    };
    axios.post('files', payload)
      .then(res => {
        onChange(res.data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <div
        style={{ height: height }}
        className='wrapper-upload-avatar'
      >
        <Upload
          disabled={disabled}
          name="avatar"
          listType="picture-card"
          className="upload-avatar-custom"
          showUploadList={false}
          data={file => {
            handleUploadFile(file)
          }}
        >
          {imageSelected ? <img src={imageSelected} alt="avatar" style={{ width: '100%', maxHeight: '100%' }} /> : <></>}
        </Upload>


      </div>

      <div
        className='action-upload t-center'
      >
        Drag and drop, or <span onClick={triggerUpload} className='link'>browse</span>
      </div>
    </>
  )
}

MyUploadAvatar.propTypes = {
  height: PropTypes.string,
  disabled: PropTypes.bool
};

MyUploadAvatar.defaultProps = {
  height: '200px',
  disabled: false
};

export default MyUploadAvatar;
